export default [
  { name: 'Açores', code: 'PT-20' },
  { name: 'Aveiro', code: 'PT-01' },
  { name: 'Beja', code: 'PT-02' },
  { name: 'Braga', code: 'PT-03' },
  { name: 'Bragança', code: 'PT-04' },
  { name: 'Castelo Branco', code: 'PT-05' },
  { name: 'Coimbra', code: 'PT-06' },
  { name: 'Évora', code: 'PT-07' },
  { name: 'Faro', code: 'PT-08' },
  { name: 'Guarda', code: 'PT-09' },
  { name: 'Leiria', code: 'PT-10' },
  { name: 'Lisboa', code: 'PT-11' },
  { name: 'Madeira', code: 'PT-30' },
  { name: 'Portalegre', code: 'PT-12' },
  { name: 'Porto', code: 'PT-13' },
  { name: 'Santarém', code: 'PT-14' },
  { name: 'Setúbal', code: 'PT-15' },
  { name: 'Viana do Castelo', code: 'PT-16' },
  { name: 'Vila Real', code: 'PT-17' },
  { name: 'Viseu', code: 'PT-18' }
];
